import { parseNumber, getCountryCallingCode, formatNumber } from 'libphonenumber-js';
import { isEmpty } from 'lodash';

export const formatCodeNumber = (phoneNumber) => phoneNumber ? formatNumber(phoneNumber, 'International') : '';
export const removePlus = (str = '') => str.replace('+', '');

export const parsePhoneNumber = (phone) => {
  if (!phone) {
    return { countryCode: '', phone: '' };
  }

  const parsedPhoneNumber = parseNumber(phone);

  return {
    countryCode: parsedPhoneNumber.country ? getCountryCallingCode(parsedPhoneNumber.country) : '',
    phone: parsedPhoneNumber.phone || '',
  };
};

export const cutNationalPrefixFromPhoneNumber = phoneNumber => {
  const parsedPhoneNumber = parsePhoneNumber(phoneNumber);

  return isEmpty(phoneNumber) ? '' : `+${ parsedPhoneNumber.countryCode }${ parsedPhoneNumber.phone }`;
};

export const formatPhoneNumber = (value = {}) => {
  if (!value.countryCode && !value.phone) return null;
  return cutNationalPrefixFromPhoneNumber(`+${ value.countryCode }${ value.phone }`);
};
